jQuery(document).ready(function($) {
  function initOwlSliders() {
    if (typeof $.fn.owlCarousel !== 'function') return;
    
    if ($('.slider_row').length && !$('.slider_row').hasClass('owl-loaded')) {
      $('.slider_row').owlCarousel({
        loop: false,
        margin: 0,
        nav: false,
        dots: true,
        responsive: {
          0: { items: 1 },
          600: { items: 1 },
          1000: { items: 1 }
        }
      });
    }

    if ($('.bottom-item-slider .owl-carousel').length && !$('.bottom-item-slider .owl-carousel').hasClass('owl-loaded')) {
      $('.bottom-item-slider .owl-carousel').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: true,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          1000: { items: 3 }
        }
      });
    }
  }

  initOwlSliders();
  $(window).on('load', initOwlSliders);
  
  $(".price_filter_row .price_filter_custom").click(function(){
    var min_val = jQuery(this).attr("min");
    var max_val = jQuery(this).attr("max");
    // alert('min-'+min_val+' max-'+max_val);

    jQuery('#Mobile-Filter-Price-GTE').val(min_val);
    jQuery('#Mobile-Filter-Price-GTE').attr('max',max_val);
    jQuery('#Mobile-Filter-Price-LTE').val(max_val);
    jQuery('#Mobile-Filter-Price-LTE').attr('min',min_val);

    if(min_val!=''){
      const el = document.getElementById('Mobile-Filter-Price-GTE');
      el.value = min_val;
      el.dispatchEvent(new Event('input', { 'bubbles': true }));
    }

    if(max_val!=''){
      const el = document.getElementById('Mobile-Filter-Price-LTE');
      el.value = max_val;
      el.dispatchEvent(new Event('input', { 'bubbles': true }));
    }

    
    
  });
});

// ---------------------- Preloader hide (fixed) ---------------------- //
jQuery(function($) {
  function hidePreloader() {
    var $preloader = $("#af-preloader");
    if ($preloader.length === 0) return;
    $preloader[0].style.setProperty("display", "none", "important");
    $preloader.remove();
  }
  $(document).ready(hidePreloader);
  $(window).on("load", hidePreloader);
  setTimeout(hidePreloader, 1000); // safety net
});

if (screen.width < 581) {
  jQuery(document).ready(function($){
      jQuery('.footer__content-top .footer__blocks-wrapper').find('.footer-block__heading').click(function(){
          var isActive = jQuery(this).hasClass("active");
          jQuery('.footer-block__heading').removeClass('active')
              if (!isActive) {
          jQuery(this).toggleClass('active');
          }
          jQuery(this).next().slideToggle('fast');
          jQuery(".footer-block__heading + ul").not(jQuery(this).next()).slideUp('fast');
      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-link');
  const contents = document.querySelectorAll('.tab-content');
  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    document.getElementById(tabs[0].dataset.tab).classList.add('active');
  }
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');
    });
  });

});

jQuery(document).ready(function() {
    jQuery(window).scroll(function() {
    var sticky = jQuery('.header-wrapper'),
    scroll = jQuery(window).scrollTop();
    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
    });
});


jQuery(document).ready(function($) {
  if( getCookie('popupCookie') != 'submited'){ 
    if(getCookie('popupCookie') != 'closed' ){
      $('.popup-overlay').css("display", "block").hide().fadeIn();
    }
  }
  $('a.close').click(function(){
    $('.popup-overlay').fadeOut();
    setCookie( 'popupCookie', 'closed', 24 );
  });
  $('a.submit').click(function(){
    $('.popup-overlay').fadeOut();
    setCookie( 'popupCookie', 'submited', 24 );
  });

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
});

jQuery(document).ready(function() {
    jQuery(".custom_form__input .select__select").change(function() {
        label_class = '.'+jQuery(this).attr('label_class');
        jQuery(label_class).html(jQuery(this).val());
    }).change();
});


jQuery(document).ready(function ($) {
  $('.variation_title .opne_size_chart').on('click', function () {
    $('.size_chart_modal.fade.size_modal').removeClass('is-visible');
    $('.size_chart_modal')
      .not('.size_modal')
      .addClass('is-visible');
  });

  $('.opne_size').on('click', function () {
    $('.size_chart_modal')
      .not('.size_modal')
      .removeClass('is-visible');
    $('.size_chart_modal.fade.size_modal')
      .addClass('is-visible');
  });
  $('.close').on('click', function () {
    $(this).closest('.size_chart_modal').removeClass('is-visible');
  });
});

jQuery(document).ready(function($){
  jQuery('.size_modal variant-radios .product-form__input.product_form_input_select .button_tabs').click(function() {
   var inputValue = $(this).find('.button_tabs_row').val();
     $('#ProductSelect-0').val(inputValue).trigger("change");
    $('#ProductSelect-0').val(inputValue).attr("selected");
    jQuery('.size_modal').removeClass('is-visible');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".view-btn");
  const grid = document.querySelector(".collection .product_grid_wraper");
  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const view = this.getAttribute("data-view");
      grid.classList.remove("view-3", "view-4", "view-6");
      grid.classList.add("view-" + view);
      buttons.forEach(b => b.classList.remove("active"));
      this.classList.add("active");
    });
  });
});


// ---------------------- // NEW PREMIUM ANIMATIONS // ---------------------- //
document.addEventListener("DOMContentLoaded", function () {
    if (typeof ScrollReveal === 'undefined') return;
    ScrollReveal().reveal('.reveal , .view-by , .related-products ', {
        delay: 200,
        distance: '50px',
        origin: 'bottom',   
        duration: 1000,     
        easing: 'ease-in-out',
        interval: 100
    });
    ScrollReveal().reveal('.reveal-bottom-item', {
        delay: 200,
        distance: '50px',
        origin: 'bottom',
        duration: 1000,
        easing: 'ease-in-out',
        interval: 200
    });
    ScrollReveal().reveal('.fade-in-scroll , .product.product--medium .grid__item.product__media-wrapper ', {
        delay: 20,
        duration: 500,
        distance: '0px',
        opacity: 0,
        scale: 0.97,
        easing: 'ease-in-out',
        interval: 80
    });
    ScrollReveal().reveal('.reveal-bottom', {
        origin: 'bottom',
        distance: '50px',
        duration: 1000
    });
    ScrollReveal().reveal('.reveal-right', {
        origin: 'right',
        distance: '80px',
        duration: 1300,
        easing: 'ease-in-out'
    });
    ScrollReveal().reveal('.reveal-left', {
        origin: 'left',
        distance: '80px',
        duration: 1300,
        easing: 'ease-in-out'
    });
    ScrollReveal().reveal('.zoom-in ', {
        duration: 1000,
        scale: 0.85, 
        opacity: 0,   
        easing: 'ease-out',
        reset: false
    });
    ScrollReveal().reveal('.rotate-in', {
        rotate: { x: 0, y: 0, z: 45 },
        duration: 1200,
        opacity: 0,
        distance: '0px',
        easing: 'ease-in-out'
    });
    ScrollReveal().reveal('.flip-up', {
        rotate: { x: -90, y: 0, z: 0 },
        duration: 1200,
        opacity: 0,
        easing: 'ease-out',
    });
    ScrollReveal().reveal('.blur-in', {
        opacity: 0,
        duration: 1200,
        scale: 0.9,
        easing: 'ease',
        beforeReveal: function(el) {
            el.style.filter = "blur(8px)";
        },
        afterReveal: function(el) {
            el.style.filter = "blur(0px)";
        }
    });
    ScrollReveal().reveal('.skew-in', {
        opacity: 0,
        duration: 1200,
        easing: 'ease-out',
        beforeReveal(el) {
            el.style.transform = "skewY(8deg)";
        },
        afterReveal(el) {
            el.style.transform = "skewY(0deg)";
        }
    });
    ScrollReveal().reveal('.lift-shadow', {
        distance: '20px',
        origin: 'bottom',
        duration: 900,
        opacity: 0,
        beforeReveal(el) {
            el.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
        },
        afterReveal(el) {
            el.style.boxShadow = "0 0 0 rgba(0,0,0,0)";
        }
    });
    ScrollReveal().reveal('.random-fade', {
        duration: 1000,
        distance: '30px',
        opacity: 0,
        origin: ['left','right','bottom'][Math.floor(Math.random()*3)],
        interval: 200
    });
    ScrollReveal().reveal('.zoom-out', {
        scale: 1.2,
        opacity: 0,
        duration: 1100,
        easing: 'ease-out'
    });
    ScrollReveal().reveal('.slide-rotate', {
        distance: '60px',
        origin: 'bottom',
        rotate: { x: 0, y: 0, z: -10 },
        opacity: 0,
        duration: 1300,
        easing: 'ease-in-out'
    });

    // Safety net: ensure elements are revealed even if scroll/network hangs
    setTimeout(function() {
      document.querySelectorAll('.reveal, .reveal-bottom, .reveal-bottom-item, .zoom-in, .fade-in-scroll').forEach(function(el) {
        if (window.getComputedStyle(el).opacity === '0') {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          el.style.transform = 'none';
        }
      });
    }, 1200);
});


  (function () {
    if (window.__videoHoverInit) return;
    window.__videoHoverInit = true;

    /*
      Product-card hover video (snippets/card-product.liquid → <video class="hover-video">).

      - Events are delegated to `document`, so cards added after page load (collection
        "Load More", session-restored grids, AJAX filtering) work without re-initialising.
      - Videos carry no `autoplay` and use preload="none": a video is only fetched and
        played when its card is hovered (desktop) or tapped (touch). Loading every video
        up front is what made mobile Safari refuse to play some of them.
      - State classes on .card-wrapper (styled in my_custom.css):
          .hover-video-active  → card is hovered/tapped, the <video> is shown
          .hover-video-playing → browser confirmed playback, only now the still image hides
        The still image is never hidden before the video is playing, so a card can't go blank.
    */
    var ACTIVE = 'hover-video-active';
    var PLAYING = 'hover-video-playing';
    var currentCard = null;
    var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

    function cardOf(el) {
      return el && el.closest ? el.closest('.card-wrapper') : null;
    }

    function videoOf(card) {
      return card ? card.querySelector('video.hover-video') : null;
    }

    function isHoverVideo(el) {
      return !!(el && el.classList && el.classList.contains('hover-video') && el.tagName === 'VIDEO');
    }

    function prepare(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function enterCard(card) {
      var video = videoOf(card);
      if (!video) return;
      if (currentCard && currentCard !== card) leaveCard(currentCard);
      currentCard = card;
      card.classList.add(ACTIVE);
      prepare(video);
      if (video.preload === 'none') video.preload = 'auto';

      if (!video.paused && video.readyState >= 2) {
        card.classList.add(PLAYING);
        return;
      }

      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          // Playback refused (e.g. iOS Low Power Mode): keep the still image visible.
          if (currentCard === card) card.classList.remove(ACTIVE, PLAYING);
        });
      }
    }

    function leaveCard(card) {
      if (currentCard === card) currentCard = null;
      card.classList.remove(ACTIVE, PLAYING);
      var video = videoOf(card);
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }

    // Media events do not bubble, so listen in the capture phase.
    document.addEventListener('playing', function (e) {
      if (!isHoverVideo(e.target)) return;
      var card = cardOf(e.target);
      if (card && card.classList.contains(ACTIVE)) card.classList.add(PLAYING);
    }, true);

    ['pause', 'emptied', 'error'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!isHoverVideo(e.target)) return;
        var card = cardOf(e.target);
        if (card) card.classList.remove(PLAYING);
      }, true);
    });

    // Hover in / out (a tap on iOS also dispatches these).
    document.addEventListener('mouseover', function (e) {
      var card = cardOf(e.target);
      if (!card || !videoOf(card)) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      enterCard(card);
    });

    document.addEventListener('mouseout', function (e) {
      var card = cardOf(e.target);
      if (!card || !videoOf(card)) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      leaveCard(card);
    });

    // Touch: tapping anywhere outside the active card stops its video.
    document.addEventListener('touchstart', function (e) {
      if (!currentCard) return;
      if (cardOf(e.target) !== currentCard) leaveCard(currentCard);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && currentCard) leaveCard(currentCard);
    });

    // Desktop only (mouse present): pre-fetch videos as their cards scroll into view,
    // so the hover starts instantly. Touch devices stay strictly on-demand.
    var warmObserver = null;
    if (canHover && 'IntersectionObserver' in window) {
      warmObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target;
          warmObserver.unobserve(video);
          prepare(video);
          if (video.preload === 'none') {
            video.preload = 'auto';
            try { video.load(); } catch (e) {}
          }
        });
      }, { rootMargin: '200px 0px' });
    }

    function observeVideos(root) {
      if (!warmObserver) return;
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('video.hover-video').forEach(function (video) {
        if (video.__hoverWarmObserved) return;
        video.__hoverWarmObserved = true;
        warmObserver.observe(video);
      });
    }

    function init() {
      // A session-restored grid may carry serialised state classes; clear them.
      document.querySelectorAll('.' + ACTIVE + ', .' + PLAYING).forEach(function (card) {
        card.classList.remove(ACTIVE, PLAYING);
      });

      observeVideos(document);

      if (warmObserver && 'MutationObserver' in window) {
        new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType !== 1) continue;
              if (isHoverVideo(node)) observeVideos(node.parentNode);
              else if (node.querySelector && node.querySelector('video.hover-video')) observeVideos(node);
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();


document.addEventListener('DOMContentLoaded', function () {
  function resumeAllAutoplayVideos() {
    document.querySelectorAll('video.autoplay-video, video.custom-video').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (video.paused) {
        video.play().catch(function () {});
      }
    });
  }

  resumeAllAutoplayVideos();
  window.addEventListener('load', resumeAllAutoplayVideos);

  // Resume on ANY user gesture (essential for mobile Low Power Mode)
  ['click', 'touchstart', 'touchend', 'scroll', 'pointerdown'].forEach(function (evt) {
    document.addEventListener(evt, resumeAllAutoplayVideos, { passive: true, once: false });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  document.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
    item.addEventListener('click', function () {
      var targetId = this.getAttribute('data-target');
      if (!targetId) return;

      setTimeout(function () {
        var slide = document.querySelector('.product__media-item[data-media-id="' + targetId + '"]');
        if (!slide) return;
        var video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(function () {});
        }
      }, 500);
    });
  });

// Slider change par video play
var sliderEl = document.querySelector('#GalleryViewer-template--18508191564051__main');
if (sliderEl) {
  var sliderObserver = new MutationObserver(function () {
    var activeSlide = document.querySelector('.product__media-item.is-active');
    if (!activeSlide) return;
    var video = activeSlide.querySelector('video');
    if (video) {
      video.muted = true;
      video.play().catch(function () {});
    }
  });
  sliderObserver.observe(sliderEl, { 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['class'] 
  });
}

});


document.querySelectorAll('.list-menu--megamenu').forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.classList.add('mega-menu-open');
    });
    item.addEventListener('mouseleave', () => {
      item.classList.remove('mega-menu-open');
    });
});


  
document.addEventListener('DOMContentLoaded', function () {
  const navLinks = document.querySelectorAll('.aside a');

  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      navLinks.forEach(l => l.classList.remove('current'));
      this.classList.add('current');

      const targetId = this.getAttribute('href').replace('#', '');
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        const offset = 100; // jitna niche rakhna ho
        const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
    // ShopifyChat pehle hide karo
    const style = document.createElement('style');
    style.textContent = '#ShopifyChat { opacity: 0 !important; visibility: hidden !important; }';
    document.head.appendChild(style);

    const chatBtn = document.querySelector('.chat-online .link.animate-arrow');
    
    if (chatBtn) {
      chatBtn.addEventListener('click', function (e) {
        e.preventDefault();
        
        // Click pe ShopifyChat show karo
        style.textContent = '#ShopifyChat { opacity: 1 !important; visibility: visible !important; }';
        
        // Shadow DOM button click
        const inboxBtn = document.querySelector('inbox-online-store-chat');
        if (inboxBtn) {
          const shadowBtn = inboxBtn.shadowRoot?.querySelector('button');
          if (shadowBtn) {
            shadowBtn.click();
          }
        }
      });
    }
});

jQuery(document).ready(function($) {
    $('#button-body').css({
        'color': '#000',
        'background': '#000',
        'margin-bottom': '10px !important'
    });
});




// ---------------------- Tidio Chat Custom Styling ---------------------- //
function onTidioChatApiReady() {
  tidioChatApi.adjustStyles(`
    #tidio {
      margin-bottom: 15px;
    }

    .grid-layout .widgetLabel {
      border-radius: 0;
      padding: 8px 15px;
      height: fit-content;
      font-size: 13px;
      right: 55px !important;
    }

    #button-body {
      width: 45px;
      height: 45px;
    }

    #button button i {
      height: 15px;
      width: 15px;
    }

    #tidio-chat {
      z-index: 9999999999 !important;
    }


    #tidio-chat-root h2 span {
      font-size: 12px;
      font-family: sweet-sans-pro;
      text-transform: uppercase;
    }

    #tidio-chat-root span {
      font-size: 12px;
      font-family: sweet-sans-pro;
    }

    #tidio-chat-root h2 {
      line-height: normal;
      display: flex;
      font-size: 13px;
      margin: 0;
    }

    #tidio-chat-root .chat-header .tidio-1ypjua1 {
      gap: 5px;
    }

    @media only screen and (max-width: 980px) {
      #tidio {
        margin-bottom: 15px;
      }
    }
  `);
}

if (window.tidioChatApi) {
  window.tidioChatApi.on('ready', onTidioChatApiReady);
} else {
  document.addEventListener('tidioChat-ready', onTidioChatApiReady);
}




document.addEventListener('DOMContentLoaded', function () {
  // Contact page ke "Chat Online" card ke andar wala link dhoondo
  var chatBtn = document.querySelector('.content-container.chat-online a[href="#"]') 
                || Array.from(document.querySelectorAll('a')).find(a => a.textContent.trim() === 'Chat');

  if (chatBtn) {
    chatBtn.addEventListener('click', function (e) {
      e.preventDefault();

      function openTidio() {
        if (window.tidioChatApi) {
          window.tidioChatApi.show();
          window.tidioChatApi.open();
        }
      }

      if (window.tidioChatApi) {
        openTidio();
      } else {
        document.addEventListener('tidioChat-ready', openTidio);
      }
    });
  }
});
